import { RootState } from "../../../../../store";

import { commitmentsDataForGranularSelector } from "../commitmentsDataForGranularSelector";

export const savingsPlansCoverageAverageSelector = (
  state: RootState,
): number | null => {
  const data = commitmentsDataForGranularSelector(state);

  return data?.totals?.average_coverage ?? null;
};
